import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Icon from "../Icon/Icon.tsx";
import AnimationContainer from "../../Reusable/AnimationContainer/AnimationContainer.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";

const colorsEnum = {
  info: "#40D2EF",
  warning: "#F5B427",
  error: "#E03F3F",
  success: "#6FCF97",
};

const iconsEnum = {
  info: "i",
  warning: "warning",
  error: "warning",
  success: "check",
};

const JumboToast = ({ props, children }) => {
  const [timer, setTimer] = useState(props.autoDismissTimeout || 5000);
  const [hover, setHover] = useState(false);

  const clonedChild =
    typeof children === "string"
      ? children
      : React.cloneElement(children, {
          closeNotiFunc: props.onDismiss,
        });

  // setInterval on mount, clearting on hover and unmount
  useEffect(() => {
    const timerId = setInterval(() => {
      setTimer((timer) => timer - 100);
    }, 100);

    if (hover) {
      clearInterval(timerId);
    }

    return () => clearInterval(timerId);
  }, [hover]);

  // on timer end, call onDismiss
  useEffect(() => {
    if (timer <= 0) {
      props.onDismiss();
    }
  }, [timer]);

  return (
    <AnimationContainer
      animationOn={props.transitionState === "entered"}
      timeout={props.transitionDuration}
      animationClassName={"toast-animation"}
    >
      <div
        className="jm-custom-toast"
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        <div
          className="border-toast"
          style={{
            backgroundColor: colorsEnum[props.appearance],
            height: (timer * 100) / (props.autoDismissTimeout || 5000) + "%",
          }}
        />
        <div
          className="border-toast"
          style={{
            backgroundColor: colorsEnum[props.appearance],
            opacity: 0.3,
          }}
        />
        <div className="icon-container">
          <Icon
            name={iconsEnum[props.appearance]}
            blue={props.appearance === "info"}
            red={props.appearance === "error"}
            greenRegular={props.appearance === "success"}
            orange={props.appearance === "warning"}
          />
        </div>
        {clonedChild}
        <div className="close-toast" onClick={() => props.onDismiss()}>
          <Icon name="x" gray />
        </div>
      </div>
    </AnimationContainer>
  );
};

JumboToast.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

const PoppingToastNotification = ({ children, ...props }) => {
  const { getDirection } = useContent();
  const { toastStack, removeToast } = useToasts();

  useEffect(() => {
    const fileExistToasts = toastStack.filter(
      (toast) => toast.type === "file-exist"
    );

    // Remove all but the last toast with type "file-exist"
    if (fileExistToasts.length > 1) {
      fileExistToasts.slice(0, -1).forEach((toast) => {
        removeToast(toast.id);
      });
    }

    // Remove excess toasts if the total count exceeds 5
    if (toastStack.length > 5) {
      const numberToRemove = toastStack.length - 5;
      toastStack.slice(0, numberToRemove).forEach((toast) => {
        removeToast(toast.id);
      });
    }
  }, []);

  return (
    <div className={`toast-direction-${getDirection()}`}>
      <JumboToast props={props}>{children}</JumboToast>
    </div>
  );
};

PoppingToastNotification.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
};

export default PoppingToastNotification;
